import { queries } from "lib/build/dashboards/ltx/queries";
import { Origin } from "lib/build/events";
import { CombinedTransplant } from "lib/build/forms/ltx/patientCondition";

import { useLastEventByQuery } from "src/features/events";

export function useCombinedTransplant(): {
	value: boolean;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<CombinedTransplant>(
		queries.combinedTransplant
	);
	return event === undefined
		? { value: false }
		: {
				value: event.value === CombinedTransplant.YES,
				timestamp: event.timestamp,
				origin: event.origin
			};
}
